/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
	PlcHttpConfig,
	PlcHttpConfigToken,
	PlcQueryParams,
} from './services.models';

import { CreateGameRequest } from '../models/create-game.request';
import { Game } from '../models/game.entity';
import { GameType } from '../models/enums';
import { GamesQuery } from '../models/games.query';
import { GamesV2Query } from '../models/games-v2.query';
import { GamePageResponse } from '../models/game-page.response';
import { CreateGamePhaseRequest } from '../models/create-game-phase.request';

export type GamesFindOnePathVariables = { id: string };
export type GamesUpdatePathVariables = { id: string };

@Injectable()
export class GamesService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	public create(body: CreateGameRequest): Observable<Game> {
		return this.http.post<Game>(
			`${this.config.apiUrl}/api/v2/private/games`,
			body,
		);
	}

	/**
	 * @deprecated use findPage instead
	 */
	public findAll(query: GamesQuery): Observable<Game[]> {
		return this.http.get<Game[]>(
			`${this.config.apiUrl}/api/v2/private/games${PlcQueryParams(
				query,
			)}`,
		);
	}

	public findPage(query: GamesV2Query): Observable<GamePageResponse> {
		return this.http.get<GamePageResponse>(
			`${this.config.apiUrl}/api/v3/private/games${PlcQueryParams(
				query,
			)}`,
		);
	}

	public findOne(path: GamesFindOnePathVariables): Observable<Game> {
		return this.http.get<Game>(
			`${this.config.apiUrl}/api/v2/private/games/${path.id}`,
		);
	}

	public update(
		path: GamesUpdatePathVariables,
		body: CreateGamePhaseRequest,
	): Observable<Game> {
		return this.http.patch<Game>(
			`${this.config.apiUrl}/api/v2/private/games/${path.id}`,
			body,
		);
	}
}
